module.exports = __webpack_public_path__ + "6a44c9755e6be143318684c5a694f5a7.png";